import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
import dayjs from 'utils/dayjs-timezone';
import TimeUtils from 'utils/time';
import { updateTimes } from 'store/search-request/search-request-actions';
import { END_TIME_ADJUSTMENT } from 'constants/time';
export const useHandleEndBeforeOrEqualToStartTimes = () => {
    const dispatch = useDispatch();
    const { parkingType, timezone, startsDate, endsDate } = useReduxSearchState(); // not sure if this should be direct access or wrapper access
    useEffect(() => {
        // Parse the dates directly in the target timezone
        const starts = startsDate ? dayjs.tz(startsDate, timezone) : undefined;
        const ends = endsDate ? dayjs.tz(endsDate, timezone) : undefined;
        // check ends is before or equal to starts
        const isEndsBeforeOrSameAsStarts = ends?.isSameOrBefore(starts) || false;
        if (isEndsBeforeOrSameAsStarts) {
            const newEnds = starts
                .add(...END_TIME_ADJUSTMENT)
                .format(TimeUtils.V1_API_TIMESTAMP_FORMAT);
            dispatch(updateTimes({
                starts: starts.format(TimeUtils.V1_API_TIMESTAMP_FORMAT),
                ends: newEnds,
                isMonthly: parkingType === 'monthly',
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return { startsDate, endsDate }; // return is for testing
};
